module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-01-77b2ef8183c7b158a83ecae122888302.svg";